import React from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, useSearchParams, useLocation} from "react-router-dom";

import DetailedReport from '../controls/DetailedReport';
import { getUsersDetailedColumns } from '../controls/GetDetailedColumns';
import ReportsFilter from '../controls/ReportsFilter';
import '../App.css';
import FilterCaption from '../controls/FilterCaption';
import UserReport from '../controls/UserReport';

const FullUsers = (props) => {

    const [searchParams] = useSearchParams();
    let filterData = useSelector(state => state.reportFilter);

    const location = useLocation();

    let url = "/user";
    if (location.search)
    {
        url += location.search + '&';
    }
    else
    {
        url += '?';
    }
    url += "noStats=false&returnEmpty=false&sort=Pages DESC";
   
    return (
        <div className = "history-pane-header">
            <div className = "filter-report-picker"><ReportsFilter/></div>
            {location.search && <div className = "range-picker"><FilterCaption searchParams = {searchParams}/></div>}           
            <DetailedReport 
                api_url = {url} 
                columns = {getUsersDetailedColumns()}
                filterData = {filterData}
            />
        </div>
    );
}

const UsersPane = (props) => {  

    return (
        <div>
            <Routes>
                <Route path={"/"} element={<FullUsers/>}/>
                {<Route path=':id' element={<UserReport/>}/>}
            </Routes>
        </div>
        );
}

  
export default UsersPane;